import styled from "styled-components";

export const StyledWrapper = styled.div`
  > div:last-child {
    > div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: row;
    }

    img {
      cursor: pointer;
    }
  }
`;
